var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.TheSp.sp_sfen_show)?_c('div',{staticClass:"SfenShowBlock is-size-7 has-text-grey"},[_vm._t("sfen_part",function(){return [_vm._v(_vm._s(_vm.TheSp.xcontainer.to_simple_sfen))]},{"sfen":_vm.TheSp.xcontainer.to_simple_sfen,"xcontainer":_vm.TheSp.xcontainer})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }